import { AddressbarColor } from 'quasar'

export default () => {
  AddressbarColor.set('#c41230')
}
